var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-page"},[_c('van-nav-bar',{staticClass:"title",attrs:{"left-arrow":""},on:{"click-left":_vm.handleBack}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',[_vm._v("选择渠道")])])]),_c('div',{staticClass:"content"},[_c('channel-list',{on:{"change":_vm.handleSelect}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }